import api from '@/api';
import {
  BookStatusRequest,
  BookStatusResponse,
  BookSummaryResponse,
  ChartsRequest,
  ChartsResponse,
  Top3OfNationsResponse,
} from '@/types/book';

export const getTop3OfNations = async () => {
  const res = await api.getAxios('/user/reservation/top3');
  return res.data as Top3OfNationsResponse;
};

export const getCharts = async (payload: ChartsRequest) => {
  const res = await api.postAxios('/user/reservation/graph', payload);
  return res.data as ChartsResponse;
};

export const getBookSummary = async () => {
  const res = await api.getAxios('/user/reservation/summary');
  return res.data as BookSummaryResponse;
};

export const getBookStatus = async (payload: BookStatusRequest) => {
  const params = new URLSearchParams();
  params.append('reservationStatus', payload.reservationStatus);
  params.append('size', payload.size.toString());
  params.append('page', payload.page.toString());

  const res = await api.getAxios(
    `/user/reservation/status?${params.toString()}`,
  );
  return res.data as BookStatusResponse;
};
